import { getOpenInvoice } from '@/apis';
import { logger } from '@/utils/log';
import { enableOpenInvoiceCheckout } from '@/views/config/shopping-cart/open-invoice/constant';

export const getOpenInvoiceState = async () => {
  try {
    if (enableOpenInvoiceCheckout) {
      const data = await getOpenInvoice();
      return data.result;
    } else {
      return Promise.resolve();
    }
  } catch (error) {
    logger.error('open invoice data', error);
  }
};

/**
 * Detects whether the current browser has a built-in PDF viewer
 * @returns {boolean}
 */
export const isBrowserHasPDFViewer = () => {
  try {
    // Modern browsers
    if (navigator?.pdfViewerEnabled !== undefined) {
      return navigator.pdfViewerEnabled;
    }

    // Old browsers or not compatible with pdfViewerEnabled like Safari
    const hasPluginEnabled = navigator.mimeTypes && navigator.mimeTypes['application/pdf']
      ? navigator.mimeTypes['application/pdf'].enabledPlugin
      : null;

    return !!hasPluginEnabled;
  } catch (e) {
    logger.error('pdfViewerEnabled plugin', e);
    return false;
  }
};
